export interface DashboardModalListItem {
    title: string;
    content: JSX.Element;
}

export enum DashboardModalImage {
    ANNOUNCEMENT = 'announcement',
    NONE = 'none'
}

export interface DashboardModalData {
    title: string;
    img: DashboardModalImage;
    nextButtonText: string;
    skipButtonText: string;
    listItems: DashboardModalListItem[];
}
